<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span class="ePub-I">My husband taught me a very important thing about writing—and about life: If you want a great story, put a wedding in it. This book is dedicated to him.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?65ee7ba9